// Imports
import { PageTitle } from './_page-title.jsx';


// Stateless components

export function MobilePageHeader(props) {

    //
    // Render
    //

    return (
        <div className="page-header__wrapper">
            <div className="inner">
                <PageTitle />
            </div>
        </div>
    )

};
